export enum LogbookTableReadMode{
    ByTimeStamp,
    ByModificationDate
}